<header class="fixed top-0 left-0 right-0 z-500 w-full!">
  <a href="#main-content" class="sr-only focus:not-sr-only">Salta al contenuto principale</a>
  <div
    class="grid grid-cols-2 grid-rows-1 z-50 bg-primary-blue text-white pb-2.5 py-2 lg:px-10 lg-md:px-5 md:px-2 px-5"
  >
    <div class="flex items-center justify-start gap-2 py-2">
      <app-icon iconName="italianFlag" aria-hidden="true" />
      <p class="font-regular text-base">Ministero dell'interno</p>
      <app-divider />
      <p class="font-regular text-base">Dipartimento della Pubblica Sicurezza</p>
    </div>

    <div class="flex justify-end items-center gap-4 py-2">
      <a
        href="https://www.instagram.com/poliziadistato/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram Polizia di Stato (apre in una nuova scheda)"
        class="w-4 h-4"
        ><app-icon iconName="instagramLogo" stroke="none" fill="white" aria-hidden="true"
      /></a>
      <a
        href="https://www.facebook.com/poliziadistato.it?fref=ts"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook Polizia di Stato (apre in una nuova scheda)"
        class="w-4 h-4"
        ><app-icon iconName="facebookLogo" stroke="none" fill="white" aria-hidden="true"
      /></a>
      <a
        href="https://x.com/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X Polizia di Stato (apre in una nuova scheda)"
        class="w-4 h-4"
        ><app-icon iconName="twitterLogo" stroke="none" fill="white" aria-hidden="true"
      /></a>
      <a
        href="https://www.youtube.com/user/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="YouTube Polizia di Stato (apre in una nuova scheda)"
        class="w-4 h-4"
        ><app-icon iconName="youtubeLogo" stroke="none" fill="white" aria-hidden="true"
      /></a>
      <a
        href="https://t.me/poliziadistato"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Telegram Polizia di Stato (apre in una nuova scheda)"
        class="w-4 h-4"
      >
        <app-icon iconName="telegramLogo" stroke="none" fill="white" aria-hidden="true"
      /></a>
      <!--       <app-divider />
      <div class="relative">
        <button (click)="toggleDropdown('lingua'); $event.stopPropagation();"
          [ngClass]="{'text-text-hover': isOpen('lingua')}"
          class="font-semi-bold uppercase text-sm text-white flex items-center justify-center gap-1">
          <div class="flex gap-1">
            <p class="font-regular">ITA</p>
            <app-icon iconName="chevronDownUp" fill="white" [class.rotate-180]="isOpen('lingua')" class="self-center" />
          </div>
        </button>
        @if(isOpen('lingua')) {
        <div class="absolute top-full left-0 mt-2 bg-white border border-gray-200 shadow-lg py-2 z-50">
          <button class="block px-4 text-black hover:bg-gray-100">ITA</button>
          <button class="block px-4 text-black hover:bg-gray-100">ENG</button>
        </div>
        }
      </div> -->
      <app-divider />
      <app-profile-header />
    </div>
  </div>

  <div class="mx-auto lg:px-10 lg-md:px-5 md:px-2 -mt-3.5">
    <div class="grid grid-cols-6 lg:gap-2 justify-between bg-white shadow-lg py-5 lg:px-6 px-3">
      <a
        routerLink="/"
        class="col-span-1 flex items-center gap-2"
        aria-label="Home Polizia di Stato"
      >
        <img
          src="assets/img/Polizia-di-Stato---logo-2025v2.png"
          alt="Logo Polizia di Stato"
          class="h-8 w-auto"
        />
      </a>
    </div>
  </div>
</header>
